import Vue from 'vue'
import VueRouter from 'vue-router'
import Home   from '../views/Home.vue'
import Page   from '../views/Page.vue'
import store  from '../store'

Vue.use(VueRouter)

const routes = [
    {   path: '/',       name: 'home',   component: Home   },
    {   path: '/page/:mod/:view/:func',   name: 'page', component: Page   },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//router.beforeEach((to, from, next) => {
//    store.commit('showDrawer', false)
//
//    if(to.name === "login" || to.name === "logout" || to.name === 'initialize' ) {
//        next()
//
//    } else if(!store.state.initialized) {
//        next({
//            name  : 'initialize',
//            params: { nextUrl: to.fullPath }
//        })
//
//
//
//    } else if(store.state.user === null) {
//        next({
//            name  : 'login',
//            params: { nextUrl: to.fullPath }
//        })
//    } else {
//        next()
//    }
//})

export default router
